import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('enso-lang') || 'ro';
    } catch {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('enso-lang', lang);
    } catch {}
  }, [lang]);

  const toggleLang = () => {
    setLang((prev) => (prev === 'en' ? 'ro' : 'en'));
  };

  const setLanguage = (newLang) => {
    if (newLang === 'en' || newLang === 'ro') setLang(newLang);
  };

  // t() for static UI translations from translations.js
  const t = (key) => translations[lang]?.[key] || translations.en?.[key] || key;

  // tl() for bilingual data objects { en: '...', ro: '...' }
  const tl = (obj) => {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    return obj[lang] || obj.en || '';
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, setLanguage, t, tl }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
